import { render, staticRenderFns } from "./TableCellProductTypesButtons.vue?vue&type=template&id=a4ee8016&scoped=true"
import script from "./TableCellProductTypesButtons.vue?vue&type=script&lang=js"
export * from "./TableCellProductTypesButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ee8016",
  null
  
)

export default component.exports